
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const LocationPinIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.496 5.273v0a7.773 7.773 0 0 1 0 10.993v0l-4.201 4.202a1.832 1.832 0 0 1-2.59 0l-4.202-4.202a7.771 7.771 0 0 1 0-10.993v0a7.771 7.771 0 0 1 10.993 0Z" clip-rule="evenodd"/><circle cx="12" cy="11" r="3.25" stroke="currentColor" stroke-width="1.5"/></svg>
  </SvgIcon>
);
